<template>
  <div
    class="control-user"
    @mouseenter="showDropdownUser"
    @mouseleave="hideDropdownUser"
  >
    <div class="icon" @click="iconClick">
      <f-sprite-icon :icon-link="$options.icons.IconUser.id" />
      <ui-badge
        v-if="LOGGED_IN"
        :text="bonuses"
        color="#95D4E9"
        max-width="50"
      />
    </div>
    <div class="dropdown">
      <ui-dropdown
        :visible="dropDownVisible"
        @on-close="dropDownVisible = false"
        overlay-height="40"
        right
      >
        <ul class="control-user-account">
          <li><a href="/account">Профиль<span>{{ ACCOUNT.firstName }}</span></a></li>
          <li><a href="/account/orders">Заказы</a></li>
          <li><a href="/account/addresses">Адреса</a></li>
          <li><a href="/account/subscribes">Подписки</a></li>
          <li><a href="/account/club">Клубная программа<ui-badge :text="bonusesWithText" size="large" color="#95D4E9" max-width="100" /></a></li>
          <li><a href="/account/logout">Выход<f-sprite-icon :icon-link="$options.icons.IconExit.id" /></a></li>
        </ul>
      </ui-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

/* Icons */
import IconExit from '../../assets/icons/exit.svg';
import IconUser from '../../assets/icons/user.svg';

export default {
  name: 'control-user',
  icons: {
    IconUser,
    IconExit,
  },

  inject: ['adaptive'],

  data: () => ({
    dropDownVisible: false,
    modalVisible: false,
  }),

  computed: {
    ...mapGetters({
      LOGGED_IN: 'user/loggedIn',
      ACCOUNT: 'user/account',
      BONUSES: 'user/bonuses',
    }),

    bonuses() {
      return `${this.$options.filters.price(this.BONUSES)}`;
    },

    bonusesWithText() {
      return `${this.bonuses} ${this.$options.filters.decl(this.BONUSES, 'бонус', ['', 'а', 'ов'])}`;
    },

    isDropdownAvailable() {
      return this.adaptive.isDesktop && this.LOGGED_IN;
    }
  },

  mounted() {
    this.$f.$on('login', () => {
      this.modalVisible = false;
    });
  },

  methods: {
    iconClick() {
      const loggedIn = this.LOGGED_IN;

      this.$f.login().then(() => {
        if (!loggedIn && this.adaptive.isDesktop) return;

        !this.adaptive.isDesktop ? this.$f.showNav('account') : this.toAccount();
      }).catch(() => {});
    },

    toAccount() {
      location = '/account';
    },

    showDropdownUser() {
      if (this.isDropdownAvailable) this.dropDownVisible = true;
    },

    hideDropdownUser() {
      if (this.isDropdownAvailable) this.dropDownVisible = false;
    },
  },

}
</script>

<style lang="scss">
.control-user {
  display: flex;
  flex-wrap: wrap;
}

@include breakpoint("desktop") {
  .control-user {
    .ui-dropdown {
      width: 280px;
    }

    &-account {
      list-style: none;
      margin: 8px 0;
      line-height: 24px;
      font-size: 14px;
      color: $black;

      li {
        a {
          display: flex;
          padding: 8px 12px;
          &:hover {
            background: $gray_bgr;
          }
          span {
            color: $gray;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding-left: 16px;
          }
          > *:last-child {
            margin-left: auto;
          }
        }
        &:last-child {
          // ВЫХОД
          border-top: 1px solid $gray_lu;
          .sprite-icon {
            color: $gray;
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
}
</style>
